import React, { useEffect, useState } from "react";
import { dateToLongStr } from "../common";
import Swal from "sweetalert2";
import { checkMvrPassToServer, finalSubmitToServer } from "../apis";


const ReviewDetails = ({
  /* basicInfos, */
  setPageNo,
  setIsDone,
  credentials,
  /* driverDocs, */
  termConAcceptedNew,
 //
}) => {
  
  const basicInfos = JSON.parse(localStorage.getItem("driverInfoData")) || {};

  const violations = JSON.parse(localStorage.getItem("form_4")) || [];
  const accidents = JSON.parse(localStorage.getItem("form_5")) || [];
  const experiences = JSON.parse(localStorage.getItem("form_6")) || [];
  const employmentHistories = JSON.parse(localStorage.getItem("form_7")) || [];
  const preEmployment = JSON.parse(localStorage.getItem("preEmploymentData")) || {};
  const otherInformation = JSON.parse(localStorage.getItem("other_information_data")) || {};
  const driverDocs = JSON.parse(localStorage.getItem("uploadedDocData")) || {};
  /////
  const [imageSrc, setImageSrc] = useState('');
  const [checkAccepted, setCheckAccepted] = useState(false);
   const [uploadedDocData, setUploadedDocData] = useState([]);
  ////
  useEffect(() => {
    // Retrieve existing data from local storage
    const storedData = localStorage.getItem('uploadedDocData');
    const existingData = storedData ? JSON.parse(storedData) : [];
    setUploadedDocData(existingData);
  }, []);

  ///
  useEffect(() => {
    // Retrieve the base64 string from local storage
    const compressedImageURL = localStorage.getItem('compressedImageURL');

    // Set the state with the base64 string
    setImageSrc('data:image/jpeg;base64,' + compressedImageURL);
  }, []);
  let licenses = [];

  if (localStorage.getItem("form_15")) {
    licenses = JSON.parse(localStorage.getItem("form_15"));
  } else if (localStorage.getItem("form_2")) {
    licenses = JSON.parse(localStorage.getItem("form_2"));
  }
  let addresses = [];

  if (localStorage.getItem("form_3")) {
    addresses = JSON.parse(localStorage.getItem("form_3"));
  } else if (localStorage.getItem("form_16")) {
    addresses = JSON.parse(localStorage.getItem("form_16"));
  }
 
  // Use credentials values or fallback to local storage
  const duid = credentials.duid || localStorage.getItem('duid');
  const parentId = credentials.parent_id || localStorage.getItem('parent_id');

  // Create a new object with the updated credentials
  const updatedCredentials = {
    duid: duid,
    parent_id: parentId,
  };
/*   console.log("status", termConAcceptedNew); */
  let edit1 = 1;
  let edit2 = 2;
  let edit3 = 3;
  let edit4 = 10;
  if (termConAcceptedNew) {
    edit1 = 14;
    edit2 = 15;
    edit3 = 16;
    edit4 = 17;

  }
  if (localStorage.getItem("form_16") || localStorage.getItem("form_15")) {
    termConAcceptedNew = true;
    edit1 = 14;
    edit2 = 15;
    edit3 = 16;
    edit4 = 17;
  }
  
  const finalSubmit = () => {
  /*   console.log("file submitted"); */
    Swal.fire({
      title: "Please enter password to submit",
      html: `<input type="password" id="sub_pass" class="swal2-input" placeholder="Password">`,
      confirmButtonText: "Submit",
      preConfirm: () => {
        const passwordInput = Swal.getPopup().querySelector("#sub_pass");
        if (!passwordInput) {
          Swal.showValidationMessage(`Password input not found`);
          return;
        }

        const password = passwordInput.value;
        if (!password) {
          Swal.showValidationMessage(`Please enter password`);
        }

        return { password: password };
      },
    }).then(async (result) => {
      if (!result || !result.value) {
        // Handle the case where result or result.value is undefined
       /*  console.error("Result or result.value is undefined"); */
        return;
      }
      const compressedImageURL = localStorage.getItem('compressedImageURL');
      console.log("compressedImageURLreViewcomponent", compressedImageURL)

      const res = await checkMvrPassToServer({
        mvrPassword: result.value.password,
      });

      if (!res.status) {
        Swal.fire("Incorrect Password");
      } else {
        // Clear local storage
        
        const result = await finalSubmitToServer({
          ...updatedCredentials,
        });

        if (result.status) {
          setPageNo(12);
        } else {
          Swal.fire(result.msg);
        }
      }
    });

    
  };
  // ---------- code runs onces when file loads ----------
  useEffect(() => {
    setIsDone(true);
  }, []);

  return (
    <>
      <div className="general-content driver-info review-details">
        <div className="row d-flex">
          <div className="col-md-12">
            <div className="driver-form-container">
              <div className="container">
                <div className="form-wrap">
                  <div className="row">
                    <h3 style={{ display: "inline" }}>Basic Informations</h3>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="btn btn-primary"
                      onClick={() => setPageNo(edit1)}
                    >
                      Edit
                    </button>
                  </div>
                  <br />
                  <div className="col-md-8 pl-md-0">
                    <div className="licence-list license-panel-list">
                      <ul className="data">
                        <li className="clearfix">
                          <label>Company Name</label>
                          <p>{basicInfos && basicInfos.tk_company_name ? basicInfos.tk_company_name.join() : ''}</p>
                        </li>
                        <li className="clearfix">
                          <div className="pull-left w-50">
                            <label>Name</label>
                            <p>
                              {basicInfos.d_first_name}{" "}
                              {basicInfos.d_middle_name}{" "}
                              {basicInfos.d_last_name}
                            </p>
                          </div>
                          <div className="pull-right w-50 text-right">
                            <label>Date of Birth</label>
                            <p>{basicInfos.d_date_of_birth}</p>

                          </div>
                        </li>
                        <li className="clearfix">
                          <div className="pull-left w-50">
                            <label>E-mail</label>
                            <p>{basicInfos.d_email}</p>
                          </div>
                          <div className="pull-right w-50 text-right">
                            <label>Phone Number</label>
                            <p>{basicInfos.d_phone_number}</p>
                          </div>
                        </li>
                        {termConAcceptedNew ? ("") : (<>
                          <li className="clearfix">
                            <label>Social Security Number</label>
                            <p>{basicInfos.d_social_s_no}</p>
                          </li>
                        </>)}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <hr />
              <br />
              <div className="container">
                <div className="form-wrap">
                  <div className="row">
                    <h3 style={{ display: "inline" }}>Licences</h3>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="btn btn-primary"
                      onClick={() => setPageNo(edit2)}
                    >
                      Edit
                    </button>
                  </div>
                  <br />
                  <div id="license-panel">
                    {licenses.map((data, index) => (
                      <div className="col-md-4 pl-md-0">
                        <div
                          id={"panel" + data.id}
                          key={index}
                          className="licence-list license-panel-list"
                        >
                          <ul className="data">
                            <li className="clearfix">
                              <label>License Number</label>
                              <span className="value lic-no">
                                {data.d_license_number}
                              </span>
                            </li>
                            {termConAcceptedNew ? ("") : (<>
                              <li className="clearfix">
                                <div className="pull-left w-50">
                                  <label>Expires</label>
                                  <span className="value">
                                    {data.d_license_exp_date}
                                  </span>
                                </div>
                                <div className="pull-right w-50 text-right">
                                  <label>Type</label>
                                  <span className="value">
                                    {data.d_license_type}
                                  </span>
                                </div>
                              </li>
                            </>)}
                            <li className="clearfix">
                              <label>Issuing Authority</label>
                              <span className="value">
                                {data.d_state_issue}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <br />
              <hr />
              <br />
              <div className="container">
                <div className="form-wrap">
                  <div className="row">
                    <h3 style={{ display: "inline" }}>Addresses</h3>
                    &nbsp;&nbsp;&nbsp;
                    <button
                      className="btn btn-primary"
                      onClick={() => setPageNo(edit3)}
                    >
                      Edit
                    </button>
                  </div>
                  <br />
                  <div id="license-panel">
                    {addresses.map((data, index) => (
                      <div className="col-md-4 pl-md-0">
                        <div
                          id={"panel" + data.id}
                          key={index}
                          className="licence-list address-panel-list"
                        >
                          <ul className="data">
                            <li className="clearfix">
                              <div className="address">
                                <b>{data.d_current_address}</b>
                                <br />
                                {data.d_current_city}
                                <br />
                                {data.d_current_province}, {data.d_current_zip}
                                <br />
                                {data.d_current_country}
                                <br />
                                <label>Number of years:&nbsp; </label>
                                {data.d_current_years}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <br />
              <br />
              <br />
              {termConAcceptedNew ?
                <>
                  <div className="container">
                    <div className="form-wrap">
                      <div className="row">
                        <h3 style={{ display: "inline" }}>Driver Documents</h3>
                        &nbsp;&nbsp;&nbsp;
                        <button
                          className="btn btn-primary"
                          onClick={() => setPageNo(17)}
                        >
                          Edit
                        </button>
                      </div>
                      <br />
                   
                 <div id="license-panel">
  {uploadedDocData &&
    uploadedDocData.map((data, index) => (
      <div className="col-md-4 pl-md-0" key={index}>
        <div
          id={"panel" + data.docType.id}
          className="licence-list license-panel-list"
        >
          <ul className="data">
            <li className="clearfix">
              <label>{data.docType.ducument_desc}</label>
            </li>
            {data.checkAccepted ? (
              <li className="clearfix">
                <span className="value lic-no">Document not provided.</span>
              </li>
            ) : (
              // Use conditional rendering for the compressed image
              <li className="clearfix" key={data.docType.id} width="120px" height="76px">
                {/* Retrieve the compressed image URL from local storage */}
                {data.docType.id && (
                  <>
                    {(() => {
                      const compressedImageUrlKey = `compressedImageURL_${data.docType.id}`;
                      const compressedImageUrl = localStorage.getItem(compressedImageUrlKey);

                      // Use the retrieved compressed image URL
                      return <img src={compressedImageUrl} alt="Uploaded Document" width="120px" height="76px" />;
                    })()}
                  </>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>
    ))}
</div>
 





                    </div>
                  </div>
                </> : ""
              }
              <br />
              <hr />
              <br />
              {termConAcceptedNew ? "" :
                <>

                  <div className="container">
                    <div className="form-wrap">
                      <div className="row">
                        <h3 style={{ display: "inline" }}>Violations</h3>
                        &nbsp;&nbsp;&nbsp;
                        <button
                          className="btn btn-primary"
                          onClick={() => setPageNo(4)}
                        >
                          Edit
                        </button>
                      </div>
                      <br />
                      <div id="license-panel">
                        {violations.map((data, index) => (
                          <div className="col-md-4 pl-md-0">
                            <div
                              id={"panel" + data.id}
                              key={index}
                              className="licence-list violation-panel-list"
                            >
                              <ul className="data">
                                <li className="clearfix">
                                  <label>Charge</label>
                                  <span className="value lic-no">
                                    {data.d_trfic_charge}
                                  </span>
                                </li>
                                <li className="clearfix">
                                  <div className="pull-left w-50">
                                    <label>Date</label>
                                    <span className="value">
                                      {data.d_trfic_todate}
                                    </span>
                                  </div>
                                  <div className="pull-right w-50 text-right">
                                    <label>Penalty</label>
                                    <span className="value">
                                      {data.d_trfic_penalty}
                                    </span>
                                  </div>
                                </li>
                                <li className="clearfix">
                                  <label>Location</label>
                                  <span className="value">
                                    {data.d_trfic_location}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <br />
                  <hr />
                  <br />
                  <div className="container">
                    <div className="form-wrap">
                      <div className="row">
                        <h3 style={{ display: "inline" }}>Accidents</h3>
                        {/* &nbsp;&nbsp;&nbsp;
                    <button
                      className="btn btn-primary"
                      onClick={() => setPageNo(5)}
                    >
                      Edit
                    </button> */}
                      </div>
                      <br />
                      <div id="license-panel">
                        {accidents.map((data, index) => (
                          <div className="col-md-4 pl-md-0">
                            <div
                              id={"panel" + data.id}
                              key={index}
                              className="licence-list accident-panel-list"
                            >
                              <ul className="data">
                                <li className="clearfix">
                                  <label>Nature of Accident</label>
                                  <span className="value lic-no">
                                    {data.d_accident_nature}
                                  </span>
                                </li>
                                <li className="clearfix">
                                  <div className="pull-left w-50">
                                    <label>Date</label>
                                    <span className="value">
                                      {data.d_accident_todate}
                                    </span>
                                  </div>
                                  <div className="pull-right w-50 text-right">
                                    <label>Injury</label>
                                    <span className="value">
                                      {data.d_accident_injury}
                                    </span>
                                  </div>
                                </li>
                                <li className="clearfix">
                                  <label>Fatality</label>
                                  <span className="value">
                                    {data.d_accident_fatality}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <br />
                  <hr />
                  <br />
                  <div className="container">
                    <div className="form-wrap">
                      <div className="row">
                        <h3 style={{ display: "inline" }}>Experiences</h3>
                        &nbsp;&nbsp;&nbsp;
                        <button
                          className="btn btn-primary"
                          onClick={() => setPageNo(6)}
                        >
                          Edit
                        </button>
                      </div>
                      <br />
                      <div id="license-panel">
                        {experiences.map((data, index) => (
                          <div className="col-md-4 pl-md-0">
                            <div
                              id={"panel" + data.id}
                              key={index}
                              className="licence-list experience experience-panel-list"
                            >
                              <ul className="data ">
                                <li className="clearfix">
                                  <div className="address">
                                    <b>
                                      {data.d_class_equipment}
                                      <label>&nbsp;with&nbsp; </label>
                                      {data.d_equipment_name}
                                    </b>
                                    <br />
                                    <label>Entry Level Training: &nbsp; </label>
                                    <b>{data.d_class_elt}</b>
                                    <br />
                                    <b>
                                      {data.d_from}- {data.d_to}
                                    </b>
                                    <br />
                                    <label>Appx. Miles: &nbsp;</label>
                                    <b>{data.approx}</b>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <br />
                  <hr />
                  <br />
                  <div className="container">
                    <div className="form-wrap">
                      <div className="row">
                        <h3 style={{ display: "inline" }}>Employment Histories</h3>
                        &nbsp;&nbsp;&nbsp;
                        <button
                          className="btn btn-primary"
                          onClick={() => setPageNo(7)}
                        >
                          Edit
                        </button>
                      </div>
                      <br />
                      <div id="license-panel">
                        {employmentHistories.map((data, index) => (
                          <div className="col-md-4 pl-md-0">
                            <div
                              id={"panel" + data.id}
                              key={index}
                              className="licence-list employment-panel-list"
                            >
                              <ul className="data">
                                <li className="clearfix">
                                  <label>Company Name</label>
                                  <span className="value lic-no">
                                    {data.eh_company_name}
                                  </span>
                                </li>
                                <li className="clearfix">
                                  <div className="pull-left w-50">
                                    <label>City</label>{" "}
                                    <span className="value">{data.eh_city}</span>
                                  </div>
                                  <div className="pull-right w-50 text-right">
                                    <label>State/Province</label>
                                    <span className="value">{data.eh_state}</span>
                                  </div>
                                </li>
                                <li className="clearfix">
                                  <label>Contact Person</label>
                                  <span className="value">
                                    {data.eh_company_cperson}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <br />
                  <hr />
                  <br />
                  <div className="container">
                    <div className="row">
                      <h3 style={{ display: "inline" }}>Pre Employment</h3>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        className="btn btn-primary"
                        onClick={() => setPageNo(8)}
                      >
                        Edit
                      </button>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Tested Positive For Substance Abuse?</label>
                          <p>{preEmployment.testdpostvsubabs}</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Refused A Substance Abuse Test?</label>
                          <p>{preEmployment.refusedsubtabtest}</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Tested Positive For Alcohol Misuse?</label>
                          <p>{preEmployment.testdposvealchmisue}</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Refused An Alcohal Misuse Test?</label>
                          <p>{preEmployment.refanalohlmisutest}</p>
                        </div>
                      </div>
                    </div>
                    {preEmployment.testdpostvsubabs === "Yes" ||
                      preEmployment.refusedsubtabtest === "Yes" ||
                      preEmployment.testdposvealchmisue === "Yes" ||
                      preEmployment.refanalohlmisutest === "Yes" ? (
                      <div className="row" id="sapRow">
                        <div className="col-md-12">
                          <div className="sec-header"></div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>SAP Name</label>
                            <p>{preEmployment.emphistestdname}</p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>SAP Phone</label>
                            <p>{preEmployment.emphistestdphone}</p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>SAP Address</label>
                            <p>{preEmployment.emphistestdaddress}</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <br />
                  <hr />
                  <br />
                  <div className="container ">
                    <div className="row">
                      <h3 style={{ display: "inline" }}>Other Informations</h3>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        className="btn btn-primary"
                        onClick={() => setPageNo(9)}
                      >
                        Edit
                      </button>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-md-5">
                        <div className="form-group">
                          <label>
                            Are You Currently Working for Another Employer?
                          </label>
                          <p>{otherInformation.eho_anotheremployee}</p>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div className="form-group">
                          <label>
                            Do You Intend to Work for Another Employer While
                            Employed With This Company?
                          </label>
                          <p>{otherInformation.eho_entended_work}</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>
                                Have you permit licence suspended or revoke?
                              </label>
                              <p>{otherInformation.tk_suspended_revoke}</p>
                            </div>
                          </div>
                          {otherInformation.tk_suspended_revoke === "Yes" ? (
                            <div className="col-md-12" id="step3revoke">
                              <div className="form-group">
                                <label>You must provide written statement </label>
                                <p>{otherInformation.tk_written_statment}</p>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>
                                Have you denied permit or previleage to motor
                                vehcile?
                              </label>
                              <p>{otherInformation.tk_denied_permit}</p>
                            </div>
                          </div>
                          {otherInformation.tk_denied_permit === "Yes" ? (
                            <div className="col-md-12" id="step3deniedpermit">
                              <div className="form-group">
                                <label>You must provide written statement </label>
                                <p>{otherInformation.tk_denied_written_statment}</p>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div>
                          <hr />
                        </div>
                        <div className="table-wrap">
                          <table className="table table-bordered workdays-table">
                            <thead>
                              {/* <div className="form-group">
                            <label htmlFor="not_applicable">
                              Not applicable
                            </label>
                            &nbsp;
                            <input
                              type="checkbox"
                              id="not_applicable"
                              checked={otherInformation.not_applicable}
                            />
                          </div> */}
                            </thead>
                            <tbody>
                              <tr>
                                <th>DAY</th>
                                <th>1</th>
                                <th>2</th>
                                <th>3</th>
                                <th>4</th>
                                <th>5</th>
                                <th>6</th>
                                <th>7</th>
                              </tr>
                              <tr>
                                <th>DATE</th>
                                <td>{otherInformation.dh_date7}</td>
                                <td>{otherInformation.dh_date6}</td>
                                <td>{otherInformation.dh_date5}</td>
                                <td>{otherInformation.dh_date4}</td>
                                <td>{otherInformation.dh_date3}</td>
                                <td>{otherInformation.dh_date2}</td>
                                <td>{otherInformation.dh_date1}</td>
                              </tr>
                              <tr>
                                <th>HOURS WORKED</th>
                                <td>{otherInformation.dh_val7}</td>
                                <td>{otherInformation.dh_val6}</td>
                                <td>{otherInformation.dh_val5}</td>
                                <td>{otherInformation.dh_val4}</td>
                                <td>{otherInformation.dh_val3}</td>
                                <td>{otherInformation.dh_val2}</td>
                                <td>{otherInformation.dh_val1}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="col-md-7">
                        <div className="form-group">
                          <label>
                            Date and time last relived from duty for previous day:
                          </label>
                          {/* <p>{dateToLongStr(otherInformation.dfpd)}</p> */}
                          <p>{otherInformation.dfpd}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <hr />
                  <br />
                  <div className="container">
                    <div className="form-wrap">
                      <div className="row">
                        <h3 style={{ display: "inline" }}>Driver Documents</h3>
                        &nbsp;&nbsp;&nbsp;
                        <button
                          className="btn btn-primary"
                          onClick={() => setPageNo(10)}
                        >
                          Edit
                        </button>
                      </div>
                      <br />
                     
                      <div id="license-panel">
  {uploadedDocData &&
    uploadedDocData.map((data, index) => (
      <div className="col-md-4 pl-md-0" key={index}>
        <div
          id={"panel" + data.docType.id}
          className="licence-list license-panel-list"
        >
          <ul className="data">
            <li className="clearfix">
              <label>{data.docType.ducument_desc}</label>
            </li>
            {data.checkAccepted ? (
              <li className="clearfix">
                <span className="value lic-no">Document not provided.</span>
              </li>
            ) : (
              // Use conditional rendering for the compressed image
              <li className="clearfix" key={data.docType.id} >
                {/* Retrieve the compressed image URL from local storage */}
                {data.docType.id && (
                  <>
                    {(() => {
                      const compressedImageUrlKey = `compressedImageURL_${data.docType.id}`;
                      const compressedImageUrl = localStorage.getItem(compressedImageUrlKey);

                      // Use the retrieved compressed image URL
                      return <img src={compressedImageUrl} alt="Uploaded Document" width="120px" height="76px" />;
                    })()}
                  </>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>
    ))}
</div>





                      
                    </div>
                  </div>
                  <hr />
                </>
              }
              <div style={{ textAlign: "center" }}>
                <button className="btn btn-primary" onClick={finalSubmit}>
                  Confirm & Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <StepButtons goBack={backPage} goNext={nextPage} nextAllowed={true} /> */}
    </>
  );
};

export default ReviewDetails;
